const addButton = dsf.buttons.addButton;
import handler from "./handler";

addButton({
  actionName: "statistics_cloud_inspection_by_one",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "逐个验收",
  text: "逐个验收",
  title: "逐个验收",
  icon: "renjijiaohu",
  params: [
    {
      value: "",
      desc: "打开页面的地址",
      default: "./page.html#/pc/statistical/jgdc/rwbs/bbgl/test",
      selector: "url",
    },
    {
      value: "",
      desc: "窗口名称(只会同时存在一个名称相同的页面)。",
      default: "",
    },
  ],
  handler: handler.system_open_window,
});
addButton({
  actionName: "statistics_cloud_inspection_success",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "验收通过",
  text: "验收通过",
  title: "验收通过",
  icon: "wdcyfw_yblc",
  params: [
    { value: "", desc: "模态框标题", default: "验收通过" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/ystg/ystgedit",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "80%,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_inspection_fail",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "验收不通过",
  text: "验收不通过",
  title: "验收不通过",
  icon: "wenjuan",
  params: [
    { value: "", desc: "模态框标题", default: "验收不通过" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/ysbtg/ysbtgedit",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "80%,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_sign",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "标记",
  text: "标记",
  title: "标记",
  icon: "wujiaoxing1",
  params: [
    { value: "", desc: "模态框标题", default: "标记" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/bj/xzbjtc",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "1200px,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_unmark",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "取消标记",
  text: "取消标记",
  title: "取消标记",
  icon: "icon_star_line1",
  params: [],
  handler: handler.system_empty,
});
addButton({
  actionName: "statistics_cloud_replace",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "替换",
  text: "替换",
  title: "替换",
  icon: "zhihuan",
  params: [
    { value: "", desc: "模态框标题", default: "替换" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/th/thlist",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "1000px,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_summary",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "汇总",
  text: "汇总",
  title: "汇总",
  icon: "biaodanzujian-biaoge",
  params: [
    {
      value: "",
      desc: "打开页面的地址",
      default:
        "http://41o280l564.zicp.vip/NEWSJZY/admin_client/analysis/olap/views/index1.htm?classId=0866fde2edf01c38db14f2ca383e562e&mtype=1",
      selector: "url",
    },
    {
      value: "",
      desc: "窗口名称(只会同时存在一个名称相同的页面)。",
      default: "",
    },
  ],
  handler: handler.system_open_window,
});
addButton({
  actionName: "statistics_cloud_cross_summary",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "交叉汇总",
  text: "交叉汇总",
  title: "交叉汇总",
  icon: "get",
  params: [
    { value: "", desc: "模态框标题", default: "交叉汇总" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/jchz/jchzedit",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "80%,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_inspection_progress",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "验收进度",
  text: "验收进度",
  title: "验收进度",
  icon: "renwujincheng",
  params: [
    { value: "", desc: "模态框标题", default: "验收进度" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/ysjd/ysjdlist",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "80%,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_remove_duplication",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "排重",
  text: "排重",
  title: "排重",
  icon: "shebeiguanli",
  params: [
    { value: "", desc: "模态框标题", default: "排重" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/pc/pclist",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "700px,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_examine",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "审核",
  text: "审核",
  title: "审核",
  icon: "daibanshixiang",
  params: [
    { value: "", desc: "模态框标题", default: "审核" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/sh/shlist",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "1000px,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});
addButton({
  actionName: "statistics_cloud_count_column",
  moduleName: "统计云",
  groupName: "静态列表",
  caption: "计算列",
  text: "计算列",
  title: "计算列",
  icon: "V",
  params: [
    { value: "", desc: "模态框标题", default: "计算列" },
    {
      value: "",
      desc: "打开页面的地址",
      default: "pc/statistical/ysjjzd/tylb/pszb/pszbedit",
      selector: "url",
    },
    {
      value: "",
      desc: "模态框宽,高（单位%或px或vh或vw  用,分割 高度请使用vh代替%）",
      default: "80%,500px",
    },
    {
      value: "",
      desc: "模态框保存按钮会抛出的事件, 方便二次开发",
      default: "system-dialog-save",
    },
    {
      value: "",
      desc:
        "$openDialog配置项，可以覆盖上面所有的参数（需用函数编写，返回一个配置项对象）",
      default: "无",
    },
    {
      value: "",
      desc: "按钮位置：left(居左)、center(居中)、right(居右)",
      default: "right",
    },
    {
      value: "",
      desc:
        "是否在顶层窗口弹出(如果触发弹出页面是iframe中加载，则会在顶层窗体上弹出)",
      default: "false",
    },
  ],
  handler: handler.system_pop_modal,
});

addButton({
  // actionName: "system_datagrid_common_import",
  actionName: "statistics_cloud_user_import",
  moduleName: "统计云",
  groupName: "导入",
  caption: "用户预导入",
  text: "用户预导入",
  title: "用户预导入",
  icon: "icon-shangchuan",
  isUpload: false,
  params: [
    { value: "", desc: "导入数据库表名", default: "" },
    { value: "", desc: "解析的sheetIndex", default: "" },
    { value: "", desc: "解析的开始行index", default: "" },
    { value: "", desc: "解析的开始列index", default: "" },
    {
      value: "",
      desc: "上传成功的回调函数，若弹出框内页面提供了此函数，将会被调用",
      default: "",
    },
    {
      value: "",
      desc: "请求额外字段JSON，格式：'{ 'isroot': true }'",
      default: "",
    },
    { value: "", desc: "导入页面提示文本", default: "" },
  ],
  handler: handler.statistics_cloud_user_import,
});
